




















import ContributionScheduleTabs from "@/shared/components/contributionsV3/ContributionScheduleTabs.vue";
import Widget from "@/shared/components/Widget.vue";
import { Vue, Component, Prop } from "@/shared/vuepack";
import AccountHolderDetails from "@/shared/components/AccountHolderDetails.vue";
import ConsumerLinkedBankAccounts from "../user-management/ConsumerLinkedBankAccounts.vue";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    ContributionScheduleTabs,
    Widget,
    ConsumerLinkedBankAccounts,
    AccountHolderDetails
  }
})
export default class ConsumerDetail extends Vue {
    rolePermissionStore = useRolePermissionsStore();

    @Prop()
    username: string;

    @Prop()
    activityPage: number;

    @Prop()
    schedulesPage: number;

    @Prop()
    tab: string;

    get isReadOnly (): boolean {
      return !this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalContributionCancel);
    }
}
